import '../css/input.css';
/**
 * Landing page functionality
 * Handles map initialization and solo game creation
 */
document.addEventListener('DOMContentLoaded', function () {
  // Initialize map functionality
  initializeMap();

  // Find all solo game buttons and att   ach event listeners
  const soloButtons = document.querySelectorAll('[data-solo-game]');

  soloButtons.forEach((button) => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      createSoloGame();
    });
  });
});

/**
 * Initializes the interactive map on the landing page
 */
function initializeMap() {
  // Map initialization is already handled in the inline script
  // This function is a placeholder in case you want to add more map functionality later
}

/**
 * Creates a solo game by submitting a form with pre-filled values
 */
function createSoloGame() {
  // Create a form data object with pre-filled values for solo play
  const formData = new FormData();
  formData.append('name', 'Solo Game');
  formData.append('playerName', 'Player');
  formData.append('privacy', 'PRIVATE');

  // Also set a default avatar
  const defaultAvatar = 'avatar4';

  // Show loading indicator
  const loadingDiv = document.createElement('div');
  loadingDiv.className =
    'fixed inset-0 bg-neutral bg-opacity-75 flex items-center justify-center z-50';
  loadingDiv.innerHTML = `
        <div class="bg-neutral-light p-6 rounded-xl shadow-xl text-center">
            <div class="animate-spin mb-4 mx-auto h-12 w-12 border-4 border-accent rounded-full border-t-transparent"></div>
            <p class="text-primary font-bold text-lg">Creating your solo game...</p>
        </div>
    `;
  document.body.appendChild(loadingDiv);

  // Convert FormData to URLSearchParams for application/x-www-form-urlencoded format
  const urlEncodedData = new URLSearchParams();
  for (const pair of formData.entries()) {
    urlEncodedData.append(pair[0], pair[1]);
  }

  // Submit the form data to create a lobby
  fetch('/lobbies', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: urlEncodedData,
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.text();
    })
    .then((data) => {
      // The response contains shortCode|playerId
      const parts = data.split('|');
      if (parts.length === 2) {
        const lobbyShortCode = parts[0];
        const playerId = parts[1];

        // Store player ID with lobby-specific key
        localStorage.setItem(`playerId_${lobbyShortCode}`, playerId);

        // Store player name and avatar for this lobby
        localStorage.setItem(`playerName_${lobbyShortCode}`, 'Player');
        localStorage.setItem(`playerAvatar_${lobbyShortCode}`, 'avatar4');

        // Redirect to the newly created lobby
        window.location.href = `/lobbies/${lobbyShortCode}`;
      } else {
        throw new Error('Invalid response format');
      }
    })
    .catch((error) => {
      console.error('Error creating solo game:', error);
      // Remove loading indicator
      document.body.removeChild(loadingDiv);

      // Show error message
      alert('Failed to create a solo game. Please try again.');
    });
}
